export default {
    driver_performance_implovementPlan_avgEvents: "Average Risk Events",
    driver_performance_implovementPlan_riskScore: "Risk Score",
    driver_performance_implovementPlan_totalEvents: "Total Events",
    driver_performance_implovementPlan_totalDistance: "Total Distance",
    driver_performance_implovementPlan_metric: "Metric",
    driver_performance_implovementPlan_measure: "Measure",
    driver_performance_implovementPlan_target: "Target",
    driver_performance_implovementPlan_success: "Success",
    driver_performance_implovementPlan_byDistance: "By Distance",
    driver_performance_implovementPlan_performanceImprovement: "Performance Improvement",
    driver_performance_implovementPlan_priorCoaching: "Prior Coaching",
    driver_performance_implovementPlan_notes: "Notes",

    driver_performance_implovementPlan_eventName: "Event",
    driver_performance_implovementPlan_count: "Count",
    driver_performance_implovementPlan_updatedCase: "Updated case",
    driver_performance_implovementPlan_omit: "Omit",
    driver_performance_implovementPlan_risk: "Risk",
    driver_performance_implovementPlan_yes: "Yes",
    driver_performance_implovementPlan_no: "No",
}
